class AtcModal extends HTMLElement {
  constructor() {
    super();
    this.modal = document.querySelector('#atc-modal');
    this.wrapper = this.modal.querySelector('.atc-modal__wrapper');
    this.sectionId = this.modal.getAttribute('data-section');
    this.productInfo = this.modal.querySelector('.atc-modal__add-product');
    this.productTitle = this.modal.querySelector('#product-title');
  }

  connectedCallback() {
    // Open modal when clicking an open button
    document.body.addEventListener('click', async (e) => {
      const btn = e.target.closest('[class^="atc-modal-open-"]');
      if (!btn) return;

      const productHandle = btn.dataset.productHandle;
      if (!productHandle) return;

      await this.loadProduct(productHandle);
      this.open();

      this.initVariantButtons();
      this.bindFormSubmit();
      this.initPurchaseOptions();
    });

    // Close button handler
    this.modal.addEventListener('click', (e) => {
      if (e.target.closest('.atc-modal__close')) {
        this.close();
      }
    });

    // Close when clicking outside modal content
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.close();
      }
    });
  }

  async loadProduct(productHandle) {
    try {
      this.modal.dataset.productHandle = productHandle; // ✅ store handle

      const url = `${window.Shopify.routes.root}products/${productHandle}?section_id=atc-modal`;
      const res = await fetch(url);
      const html = await res.text();

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      const newModalContent = tempDiv.querySelector('#atc-modal .atc-modal__wrapper');
      if (newModalContent) {
        this.wrapper.innerHTML = newModalContent.innerHTML;
        this.productInfo = this.modal.querySelector('.atc-modal__add-product'); // refresh ref
        this.productTitle = this.modal.querySelector('#product-title');
      }
    } catch (err) {
      console.error('Failed to load modal:', err);
    }
  }

  initVariantButtons() {
    const variantButtons = this.wrapper.querySelectorAll(".atc-modal_variants-btn");
    const hiddenInput = this.wrapper.querySelector("#selected-variant-id");

    variantButtons.forEach(btn => {
      btn.addEventListener("click", async () => {
        const selectedId = btn.dataset.variantId;

        // Remove previous selection
        variantButtons.forEach(b => b.classList.remove("is-selected"));
        // Add selection class to clicked button
        btn.classList.add("is-selected");

        // Update hidden input
        if (hiddenInput) hiddenInput.value = selectedId;

        // 🔥 Re-render section for this variant
        const url = `${window.Shopify.routes.root}products/${this.modal.dataset.productHandle}?variant=${selectedId}&section_id=${this.sectionId}`;
        try {
          const res = await fetch(url);
          const html = await res.text();

          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;

          const newContent = tempDiv.querySelector(".atc-modal__add-product");
          if (newContent) {
            this.productInfo.innerHTML = newContent.innerHTML;
            this.productTitle = this.modal.querySelector('#product-title');

            // Re-init after replacing DOM
            this.initVariantButtons();
            this.bindFormSubmit();
            this.initPurchaseOptions();

            // ✅ Reapply selection in the new DOM
            const newBtn = this.wrapper.querySelector(
              `.atc-modal_variants-btn[data-variant-id="${selectedId}"]`
            );
            if (newBtn) newBtn.classList.add("is-selected");

            // ✅ Reapply purchase option selection
            if (this.selectedSellingPlanId !== undefined) {
              const newRadio = this.wrapper.querySelector(
                `.purchase-radio-btn[value="${this.selectedSellingPlanId}"]`
              );
              if (newRadio) {
                newRadio.checked = true;
                newRadio.closest("fieldset")?.classList.add("is-selected");
              }
            }
          }
        } catch (err) {
          console.error("Failed to update section:", err);
        }
      });
    });
      // ✅ On first load: highlight the variant from hidden input
      if (hiddenInput && hiddenInput.value) {
        const initialBtn = this.wrapper.querySelector(
          `.atc-modal_variants-btn[data-variant-id="${hiddenInput.value}"]`
        );
        if (initialBtn) initialBtn.classList.add("is-selected");
      } else if (variantButtons.length) {
        // fallback: mark first button if hidden input is missing
        variantButtons[0].classList.add("is-selected");
        if (hiddenInput) hiddenInput.value = variantButtons[0].dataset.variantId;
      }
  }

  initPurchaseOptions() {
  const fieldsets = this.wrapper.querySelectorAll("fieldset.subscription, fieldset.one-time");
  const radios = this.wrapper.querySelectorAll(".purchase-radio-btn");

  radios.forEach(radio => {
    radio.addEventListener("change", () => {
      // remove highlight from all
      fieldsets.forEach(fs => fs.classList.remove("is-selected"));

      // add highlight to the fieldset of the chosen radio
      const fs = radio.closest("fieldset");
      if (fs) fs.classList.add("is-selected");

      // store selection so we can reapply after variant re-render
      this.selectedSellingPlanId = radio.value;
    });
  });

  // ✅ On init, highlight whichever is checked
  const selectedRadio = this.wrapper.querySelector(".purchase-radio-btn:checked");
  if (selectedRadio) {
    selectedRadio.closest("fieldset")?.classList.add("is-selected");
    this.selectedSellingPlanId = selectedRadio.value;
  }
  }

  bindFormSubmit() {
  const form = this.modal.querySelector('form[action="/cart/add"]');
  if (!form) return;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const formData = new FormData(form);

      // 🔍 Debug log
      console.log("FormData being sent:", formData);
      

    try {

      // Simulate a fake network error 💥
      // throw new Error("Simulated cart error: test mode");

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: formData,
      });

      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      console.log("Added to cart:", data);

      // ✅ Refresh Alpine cart store
      if (window.Alpine && Alpine.store("cart")) {
        const cartRes = await fetch("/cart.js");
        const cartData = await cartRes.json();

        let cartStore = Alpine.store("cart");

        // ✅ Sync raw values
        cartStore.items = cartData.items;
        cartStore.item_count = cartData.item_count;
        cartStore.total_price = cartData.total_price;

        // ✅ Derive subscription vs regular items
        cartStore.subscriptionItems = cartData.items.filter(i => i.selling_plan_allocation);
        cartStore.regularItems = cartData.items.filter(i => !i.selling_plan_allocation);

        // ✅ Recalculate threshold if your theme uses it
        if (cartStore.thresholds?.length) {
          cartStore.currentThreshold =
            cartStore.thresholds.find(t => cartStore.total_price >= t.threshold) || null;
        }

        // ✅ Finally, open the mini-cart
        cartStore.isOpen = true;
      } else {
        console.warn("Alpine cart store not found, fallback to reload mini-cart section.");

        // fallback: replace HTML (your old logic)
        const miniCart = document.querySelector("#mini-cart");
        if (miniCart) {
          const cartRes = await fetch(`${window.Shopify.routes.root}?section_id=mini-cart`);
          const cartHtml = await cartRes.text();
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = cartHtml;
          const newMiniCart = tempDiv.querySelector("#mini-cart");
          if (newMiniCart) miniCart.innerHTML = newMiniCart.innerHTML;
          miniCart.classList.add("mini-cart--active");
        }
      }

      this.close();
    } catch (err) {
        console.error("Add to cart failed:", err);

        const oldError = form.querySelector(".mini-cart__error");
        if (oldError) oldError.remove();

        const miniCartError = document.createElement("div");
        miniCartError.classList.add("mini-cart__error");

        const message = document.createElement("span");
        message.textContent = `The product '${this.productTitle.textContent}' is already sold out.`;
        miniCartError.appendChild(message);

        // ❌ Close button
        const closeBtn = document.createElement("span");
        closeBtn.classList.add("mini-cart__error-close");
        closeBtn.innerHTML = "&times;"; // text X (you can replace with SVG bg)
        closeBtn.addEventListener("click", () => {
          miniCartError.remove();
        });

        miniCartError.appendChild(closeBtn);
        form.appendChild(miniCartError);
    }
  });
  }


  open() {
    this.modal.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.modal.setAttribute('aria-hidden', 'true');
  }
}

customElements.define("atc-modal", AtcModal);
